import { render, staticRenderFns } from "./NTOSummary.vue?vue&type=template&id=0f856d96&"
import script from "./NTOSummary.vue?vue&type=script&lang=js&"
export * from "./NTOSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports